"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Space = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "children", "inline", "size", "align", "justify"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var PRESET_GAP_SIZES = {
  'x-small': 'spacing-02',
  'small': 'spacing-03',
  'medium': 'spacing-05',
  'large': 'spacing-06',
  'x-large': 'spacing-07'
};
var MAP_ALIGN_ITEMS = {
  'start': 'flex-start',
  'end': 'flex-end',
  'center': 'center',
  'baseline': 'baseline'
};
var MAP_JUSTIFY_CONTENT = {
  'start': 'flex-start',
  'end': 'flex-end',
  'center': 'center',
  'space-between': 'space-between',
  'space-around': 'space-around'
};
var StyledSpace = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1vp8vfn-0"
})(["", " ", " ", " ", " &>:not(:first-child){", " ", "}", ""], function (props) {
  return props.display && (0, _styledComponents.css)(["display:", ";"], props.display);
}, function (props) {
  return props.align && (0, _styledComponents.css)(["align-items:", ";"], props.align);
}, function (props) {
  return props.justify && (0, _styledComponents.css)(["justify-content:", ";"], props.justify);
}, function (props) {
  return props.width && (0, _styledComponents.css)(["width:", ";"], props.width);
}, function (props) {
  return props.horizontalGap && (0, _styledComponents.css)(["", ";"], _kDsFoundation["default"].setSpacingWithFallback('margin-left: ', props.horizontalGap));
}, function (props) {
  return props.verticalGap && (0, _styledComponents.css)(["", ";"], _kDsFoundation["default"].setSpacingWithFallback('margin-top: ', props.verticalGap));
}, function (props) {
  return props.direction === 'vertical' && (0, _styledComponents.css)(["flex-direction:column;"]);
});
var Space = exports.Space = function Space(_ref) {
  var className = _ref.className,
    children = _ref.children,
    inline = _ref.inline,
    size = _ref.size,
    align = _ref.align,
    justify = _ref.justify,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var direction = moreProps.direction;
  var defualtSize = 'small';
  var gapSize = PRESET_GAP_SIZES[size] || PRESET_GAP_SIZES[defualtSize];
  var alignItems = MAP_ALIGN_ITEMS[align];
  var justifyContent = MAP_JUSTIFY_CONTENT[justify];
  var display = 'flex';
  if (inline) {
    display = 'inline-flex';
  }
  var props = _objectSpread(_objectSpread({}, moreProps), {}, {
    align: alignItems,
    justify: justifyContent,
    display: display
  });
  switch (direction) {
    case 'horizontal':
      props = _objectSpread(_objectSpread({}, props), {}, {
        horizontalGap: gapSize
      });
      break;
    case 'vertical':
    default:
      props = _objectSpread(_objectSpread({}, props), {}, {
        verticalGap: gapSize
      });
      break;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledSpace, _extends({
    className: className
  }, props), children);
};